import { Button } from '@/design-system/button/button';
import { PayrollEvidenceLineItemView } from '@seapoint/client/src/types/entity-types';
import { LegalEntityCountry } from '@seapoint/server/enums';
import { useState } from 'react';
import { PayrollEmployee } from '../../financial-information-step/financial-information-table-column-definition';
import { RecordsTable } from './records-table';

type SelectNewEmployeesProps = {
  evidenceItems: PayrollEvidenceLineItemView[];
  isLoadingEmployees: boolean;
  addSelectedEmployees: (selectedRowIds: string[]) => void;
  skipNewEmployees: () => void;
  legalEntityCountry: LegalEntityCountry;
};

export const SelectNewEmployees = ({
  legalEntityCountry,
  evidenceItems,
  isLoadingEmployees,
  addSelectedEmployees,
  skipNewEmployees,
}: SelectNewEmployeesProps) => {
  const [selectedRowIds, setSelectedRowIds] = useState<string[]>(evidenceItems.map((record) => record.id));

  return (
    <>
      <h2 className="text-lg leading-[22px] font-medium -tracking-[0.02em]">
        We found {evidenceItems.length} new employees
      </h2>
      <p className="text-seapoint-gray-text leading-[22px] -tracking-[0.02em]">Click continue to add new employees</p>
      <RecordsTable
        records={
          evidenceItems.map((newEmployee) => ({
            ...newEmployee,
            netPay: '',
            reference: '',
          })) as PayrollEmployee[]
        }
        selectedRowIds={selectedRowIds}
        setSelectedRowIds={setSelectedRowIds}
        legalEntityCountry={legalEntityCountry}
      />
      <Button
        className="w-full"
        variant="default"
        isLoading={isLoadingEmployees}
        disabled={selectedRowIds.length === 0}
        onClick={() => addSelectedEmployees(selectedRowIds)}
      >
        Continue
      </Button>
      <Button className="w-full" variant="secondary" onClick={skipNewEmployees}>
        Don't add new employees
      </Button>
    </>
  );
};
